// Copyright (c) 2022 8th Wall, Inc.
//
// app.js is the main entry point for your 8th Wall app. Code here will execute after head.html
// is loaded, and before body.html is loaded.

// Global crash diagnostics (helps when production bundle is minified)
// - Captures TDZ errors like: "Cannot access 'E' before initialization"
// - Logs current route + basic environment info
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    try {
      const err = event?.error
      console.error('🧨 [GLOBAL window.error]', {
        message: event?.message,
        filename: event?.filename,
        lineno: event?.lineno,
        colno: event?.colno,
        stack: err?.stack,
        href: window.location?.href,
        pathname: window.location?.pathname,
        search: window.location?.search,
        userAgent: navigator?.userAgent,
      })
    } catch (e) {
      // never block
      console.error('🧨 [GLOBAL window.error] (logging failed)', e)
    }
  })

  window.addEventListener('unhandledrejection', (event) => {
    try {
      const reason = event?.reason
      console.error('🧨 [GLOBAL unhandledrejection]', {
        reason,
        stack: reason?.stack,
        href: window.location?.href,
        pathname: window.location?.pathname,
        search: window.location?.search,
      })
    } catch (e) {
      console.error('🧨 [GLOBAL unhandledrejection] (logging failed)', e)
    }
  })
}

import * as ReactApp from './react-app'

ReactApp.render()
